import React from 'react';
import NeonBorder from './NeonBorder';

const ActionButton = ({ onClick, children, className = "", variant = "primary" }) => {
  const baseClasses = "relative px-6 py-3 rounded-lg font-bold transition-all duration-300 transform active:scale-95 flex items-center justify-center gap-2";
  
  const variants = {
    primary: "bg-me-orange text-white hover:bg-orange-600 pulsating-button",
    secondary: "bg-white text-me-blue hover:bg-gray-100 border border-me-blue/20",
    danger: "bg-red-500 text-white hover:bg-red-600 pulsating-button"
  };

  if (variant === 'primary' || variant === 'danger') {
    return (
       <button onClick={onClick} className={`${baseClasses} ${variants[variant]} ${className}`}>
         {children}
       </button>
    );
  }

  // Neon border for secondary or other buttons if desired, or just standard rounded
  return (
    <NeonBorder className="inline-block">
      <button onClick={onClick} className={`${baseClasses} ${variants[variant]} w-full h-full`}>
        {children}
      </button>
    </NeonBorder>
  );
};

export default ActionButton;